import React from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, IconButton, useMediaQuery, useTheme } from '@material-ui/core';
import AppConfig from '@config';
import { Camera, ChevronRight, Renew } from '@carbon/icons-react';
import useUserActionLog, {
  Enum_Action_Button_Enum,
  CapaActivityType
} from '@hooks/useUserActionLog';
import { CapaQuotationUserFileType, CapaServiceType } from '@generated/graphql';
import { colorSet } from '@components/Provider';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import UploadPresenter from '@components/Upload';
import { MyAccountContext } from '../../MyAccountContainer';
import MenuList from './MenuList';
import { useStyles } from './styles';
import useClient from '@hooks/useClient';

interface MyAccountSideMenuProps {
  onChangeCurrentTab: (_: number) => void;
  handleLogout: () => void;
  onUpload: (data: Array<File>) => Promise<void>;
  onUpdateProfileImage: (_: any) => void;
  onOpenPictureDialog: () => void;
  open: boolean;
  inputRef: React.RefObject<HTMLInputElement>;
}

const DefaultAvatar = () => (
  <svg
    className="default_avatar"
    viewBox="0 0 146 146"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="146" height="146" rx="73" fill="#F1F3F5" />
    <path
      d="M73 46.332C58.28 46.332 46.3333 58.2787 46.3333 72.9987C46.3333 87.7187 58.28 99.6654 73 99.6654C87.72 99.6654 99.6667 87.7187 99.6667 72.9987C99.6667 58.2787 87.72 46.332 73 46.332ZM73 54.332C77.4267 54.332 81 57.9054 81 62.332C81 66.7587 77.4267 70.332 73 70.332C68.5733 70.332 65 66.7587 65 62.332C65 57.9054 68.5733 54.332 73 54.332ZM73 92.1987C66.3333 92.1987 60.44 88.7854 57 83.612C57.08 78.3054 67.6667 75.3987 73 75.3987C78.3067 75.3987 88.92 78.3054 89 83.612C85.56 88.7854 79.6667 92.1987 73 92.1987Z"
      fill="#DEE2E6"
    />
  </svg>
);

export default (props: MyAccountSideMenuProps) => {
  const context = React.useContext(MyAccountContext);
  const classes = useStyles();
  const history = useHistory();
  const { clientState } = useClient();
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));
  const { onInsertUserActionLogOne } = useUserActionLog();

  const ProfileImage =
    context.data?.files && context.data.files.length > 0
      ? context.data.files?.filter(
          (v) => v.fileType === CapaQuotationUserFileType.Profile
        )[0]
      : undefined;

  return (
    <Grid container className={classes.root}>
      <UploadPresenter
        id="profile_logo_image"
        ref={props.inputRef}
        multiple={false}
        uploadBtn={<></>}
        maxSize={10}
        onChange={props.onUpload}
        accept=".jpg, .jpeg, .png"
      />

      <Grid
        container
        className={classes.avatarRoot}
        onClick={() => history.push('/mypage/profile')}
      >
        <div
          className={classes.avatarOverlay}
          onClick={(e) => {
            e.stopPropagation();
            !ProfileImage &&
              props.inputRef &&
              props.inputRef.current &&
              props.inputRef.current.click();

            ProfileImage?.fileId && props.onOpenPictureDialog();
          }}
        >
          <Camera size={24} color={colorSet.gray900} />
          <CustomizedTypography className={'text'} variant="body2">
            사진 업로드
          </CustomizedTypography>
        </div>
        <div className="avatarBox">
          {ProfileImage && ProfileImage?.fileId !== null ? (
            <img
              className="avatar"
              alt=""
              src={AppConfig.fileApiUrl + '/file/' + ProfileImage.fileId}
            />
          ) : (
            <DefaultAvatar />
          )}
          <div className="cameraIcon">
            <Camera size={20} color={colorSet.gray900} />
          </div>
        </div>
        <div className="accounteBasicInfo">
          <CustomizedTypography className="userName">
            {clientState.managerName} 고객님
          </CustomizedTypography>
          {matches && (
            <CustomizedTypography variant="body2" color="textSecondary">
              {clientState.email}
            </CustomizedTypography>
          )}
        </div>
        {!matches && (
          <CustomizedButton
            color="dark"
            fullWidth
            variant="contained"
            size={matches ? 'small' : 'medium'}
            classes={{
              root: 'changeButton',
              label: 'changeButtonLabel'
            }}
            onClick={() => {
              onInsertUserActionLogOne(
                Enum_Action_Button_Enum.Button_Gnb_Popup_SwitchService,
                CapaActivityType.ButtonClick
              );
              if (context.handleSwitchService) {
                context.handleSwitchService(CapaServiceType.QuotationPartner);
              }
            }}
          >
            <Renew size={20} color={colorSet.gray000} />
            파트너로 전환
          </CustomizedButton>
        )}
        {matches && (
          <IconButton className="profileButton">
            <ChevronRight size={20} color={colorSet.gray600} />
          </IconButton>
        )}
      </Grid>
      <MenuList {...props} />
    </Grid>
  );
};
